export const PRODUCTS = [
  { id: "gita-handpress", deva: "गीता", title: "Bhagavad Gita · handpress edition", sub: "Sanskrit + English · with Sankara's commentary", price: 1499, kind: "Hardcover · 412 pp", stock: "in stock" },
  { id: "ramayana-7vol", deva: "रामायण", title: "Valmiki Ramayana · seven kandas", sub: "Critical edition · seven volume set", price: 6299, kind: "Boxed set · 3,200 pp", stock: "ships in 7 days" },
  { id: "mahabharata-bori", deva: "महाभारत", title: "Mahabharata · BORI critical edition", sub: "Eighteen parvas, faithfully reconstructed", price: 18500, kind: "19 volumes · cloth", stock: "limited" },
  { id: "upanishads-10", deva: "उपनिषद्", title: "Ten Principal Upanishads", sub: "Sanskrit with verse-by-verse English", price: 1199, kind: "Paperback · 540 pp", stock: "in stock" },
  { id: "rigveda-4vol", deva: "ऋग्वेद", title: "Rig Veda · complete", sub: "All ten mandalas · transliterated", price: 8499, kind: "4 volumes · hardcover", stock: "ships in 14 days" },
  { id: "yogasutra", deva: "योगसूत्र", title: "Patanjali Yoga Sutras", sub: "All 196 sutras · with traditional bhāṣya", price: 699, kind: "Paperback · 280 pp", stock: "in stock" },
  { id: "leaf-replica", deva: "ताल", title: "Palm-leaf replica · Gita 2.47", sub: "Hand-inscribed olla replica, 6×30cm", price: 2199, kind: "Artefact · handmade", stock: "made to order" },
  { id: "audio-veda", deva: "श्रुति", title: "Vedic recitation · audio archive", sub: "12 hours · traditional pathshala chanting", price: 499, kind: "Digital · lifetime", stock: "instant" },
];

export const POSTERS = [
  {
    id: "poster-om-cosmic",
    deva: "ॐ",
    title: "Om · the cosmic syllable",
    subtitle: "The first sound — before creation, after dissolution",
    verse: "ॐ पूर्णमदः पूर्णमिदं पूर्णात्पूर्णमुदच्यते। पूर्णस्य पूर्णमादाय पूर्णमेवावशिष्यते॥",
    verseTrans: "Om is whole; this is whole. From wholeness, wholeness emerges. Wholeness taken from wholeness, wholeness alone remains.",
    verseRef: "Shukla Yajur Veda · Isha Upanishad",
    meaning: "Om contains all sounds. All words are its fragments. In Om, the universe begins and ends.",
    colors: ["#d4a44a", "#f0c869", "#07060a"],
    yuga: "satya",
    price: 799,
    sizes: ["A4 (21×29.7cm)", "A3 (29.7×42cm)", "A2 (42×59.4cm)"],
  },
  {
    id: "poster-gita-chapter2",
    deva: "कर्मण्येव",
    title: "Bhagavad Gita · Chapter 2",
    subtitle: "You have the right to action, never to its fruits",
    verse: "कर्मण्येवाधिकारस्ते मा फलेषु कदाचन। मा कर्मफलहेतुर्भूर्मा ते सङ्गोऽस्त्वकर्मणि॥",
    verseTrans: "You have the right to perform your prescribed duty, but you are not entitled to the fruits of action.",
    verseRef: "Bhagavad Gita · 2.47",
    meaning: "Detachment is not inaction. It is action without anxiety about results. Do the work, let go of the outcome.",
    colors: ["#1a4a7a", "#4a8ab8", "#f4ead7"],
    yuga: "dvapara",
    price: 799,
    sizes: ["A4 (21×29.7cm)", "A3 (29.7×42cm)", "A2 (42×59.4cm)"],
  },
  {
    id: "poster-tat-tvam-asi",
    deva: "तत् त्वम्",
    title: "Tat Tvam Asi",
    subtitle: "That thou art — the most direct teaching of unity",
    verse: "तत् त्वम् असि",
    verseTrans: "That thou art. You are that absolute awareness which you seek.",
    verseRef: "Chandogya Upanishad · 6.8.7",
    meaning: "The individual self and the cosmic self are not two. What you are looking for is what is looking.",
    colors: ["#4a1a0a", "#d97a3c", "#f6ecd0"],
    yuga: "satya",
    price: 799,
    sizes: ["A4 (21×29.7cm)", "A3 (29.7×42cm)", "A2 (42×59.4cm)"],
  },
  {
    id: "poster-soham",
    deva: "सोऽहम्",
    title: "So'ham · I am That",
    subtitle: "The breath mantra — heard in every inhale and exhale",
    verse: "सोऽहम्",
    verseTrans: "I am That. The breath repeats this without teaching. Every 'ha' is That; every 'sa' is I.",
    verseRef: "Yoga Sutras · Gaudapada · Mandukya",
    meaning: "You do not need to learn this. You have always known it. Every breath is a reminder.",
    colors: ["#0a1a0a", "#3a6a3a", "#d8e8d8"],
    yuga: "satya",
    price: 799,
    sizes: ["A4 (21×29.7cm)", "A3 (29.7×42cm)", "A2 (42×59.4cm)"],
  },
  {
    id: "poster-yudhishthira",
    deva: "धर्म",
    title: "Yudhishthira's Question",
    subtitle: "What is more mysterious than the earth?",
    verse: "किमाश्चर्यमतः पृच्छामि धर्मं साध्वनुशासितुम्। येनेष्टं स्यात्प्रजानां च सर्वासामाहितागसाम्॥",
    verseRef: "Mahabharata · 12.138.5",
    meaning: "What is more wonderful than the earth? I ask you to teach dharma — by which the welfare of all beings is maintained.",
    colors: ["#3a1a07", "#8a4a1e", "#f4ead7"],
    yuga: "dvapara",
    price: 799,
    sizes: ["A4 (21×29.7cm)", "A3 (29.7×42cm)", "A2 (42×59.4cm)"],
  },
  {
    id: "poster-nachiketa",
    deva: "मृत्यु",
    title: "Nachiketa at Death's Door",
    subtitle: "The boy who would not leave until he had his answer",
    verse: "तत्त्वमसि",
    verseTrans: "You are That. Death could not hold what was already infinite.",
    verseRef: "Katha Upanishad · 2.20",
    meaning: "The self is not born and does not die. Nachiketa learned this by staying when others would have fled.",
    colors: ["#1a1a0a", "#8a7a3a", "#e8e0c8"],
    yuga: "satya",
    price: 799,
    sizes: ["A4 (21×29.7cm)", "A3 (29.7×42cm)", "A2 (42×59.4cm)"],
  },
  {
    id: "poster-shiva-tandava",
    deva: "नटेश",
    title: "Nataraja · the Cosmic Dance",
    subtitle: "Creation, preservation, dissolution — all one dance",
    verse: "यस्य द्विरदवक्त्राद्याः पुरुषा वेद कर्माणि च। स एव सर्वभूतानां प्रभवाप्यययोर्भवान्॥",
    verseRef: "Traditional · Shaiva doctrine",
    meaning: "He whose forms the Vedas and all beings reveal — He alone is the source and dissolution of all.",
    colors: ["#2a1a0a", "#c8a040", "#f4e8c0"],
    yuga: "dvapara",
    price: 799,
    sizes: ["A4 (21×29.7cm)", "A3 (29.7×42cm)", "A2 (42×59.4cm)"],
  },
  {
    id: "poster-krishna-govindam",
    deva: "गोविन्द",
    title: "Govinda · the Cowherd",
    subtitle: "Every name is a doorway to the same presence",
    verse: "गोविन्द गोविन्द गोविन्द हे हे गोविन्द गोविन्द प्रपद्ये। गोविन्द गोविन्द गोविन्द इतो गोविन्द इतो गोविन्द एतत्॥",
    verseRef: "Traditional Bhajan",
    meaning: "The cowherd is not a boy in a field. Every invocation of the name is an invocation of presence itself.",
    colors: ["#1a0a1a", "#8a3ac8", "#e8d8f4"],
    yuga: "dvapara",
    price: 799,
    sizes: ["A4 (21×29.7cm)", "A3 (29.7×42cm)", "A2 (42×59.4cm)"],
  },
];

export const DAANA_TIERS = [
  { v: 108, label: "Sankalpa", desc: "A single intention. 108 — the sacred number." },
  { v: 501, label: "Diya", desc: "Light a lamp on the wall of remembrance." },
  { v: 1008, label: "Mala", desc: "A full mala of giving. Carries 1008 names." },
  { v: 5100, label: "Granthadan", desc: "Sponsor a palm-leaf entry in the Granthalaya." },
  { v: 11000, label: "Yagna", desc: "A flame that lights other flames." },
];

export const DAANA_USES = [
  { k: "manuscripts", t: "Manuscript preservation", d: "Digitising palm-leaf granths before they crumble." },
  { k: "teachers", t: "Teachers in the gurukula tradition", d: "Stipends for those still passing the śruti by mouth." },
  { k: "open", t: "Keep this site open & ad-free", d: "Servers, hosting, and a small team that maintains the chronicle." },
];
